import { composeRenderProps } from "react-aria-components/composeRenderProps";
import {
	ModalOverlay,
	type ModalOverlayProps,
	Modal as RACModal,
} from "react-aria-components/Modal";
import { tv } from "tailwind-variants";

const overlayStyles = tv({
	base: "umb-modal-overlay fixed inset-0 top-0 start-0 w-full h-(--page-height) isolate z-20 text-center",
	variants: {
		isEntering: {
			true: "umb-modal-overlay-entering",
		},
		isExiting: {
			true: "umb-modal-overlay-exiting",
		},
	},
});

const modalStyles = tv({
	base: "umb-modal-panel w-full text-left align-middle",
	variants: {
		isEntering: {
			true: "umb-modal-panel-entering",
		},
		isExiting: {
			true: "umb-modal-panel-exiting",
		},
	},
});

export interface ModalProps extends ModalOverlayProps {
	modalClassName?: ModalOverlayProps["className"];
}
export function Modal({
	children,
	className,
	modalClassName,
	...props
}: ModalProps) {
	return (
		<ModalOverlay
			{...props}
			className={composeRenderProps(className, (className, renderProps) =>
				overlayStyles({ ...renderProps, className }),
			)}
		>
			<div className="umb-modal-viewport sticky top-0 start-0 w-full h-(--visual-viewport-height) flex items-center justify-center box-border">
				<RACModal
					className={composeRenderProps(
						modalClassName,
						(className, renderProps) =>
							modalStyles({ ...renderProps, className }),
					)}
				>
					{children}
				</RACModal>
			</div>
		</ModalOverlay>
	);
}
